import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const HorizontalStackedBarChart = () => {
  const data = {
    labels: ['True', 'Good', 'Beautiful', 'Prosperous', 'Sustainable', ['Just and', 'Well-Ordered']],
    datasets: [
      {
        data: [5, 7, 5, 5, 15, 10, 10, 10],
        backgroundColor: '#EA7369',
        barThickness: 30,
      },
      {
        data: [20, 15, 10, 10, 20, 10],
        backgroundColor: '#F77DAA',
        barThickness: 30,
      },
      {
        data: [25, 20, 20, 15, 0, 15],
        backgroundColor: 'rgba(75, 192, 192, 0.5)',
        barThickness: 30,
      },
      {
        data: [15, 25, 0, 20, 0, 20],
        backgroundColor: '#DB4CB2',
        barThickness: 30,
      },
      {
        data: [10, 0, 30, 15, 15, 0],
        backgroundColor: '#BA59E7',
        barThickness: 30,
      },
      {
        data: [0, 30, 20, 0, 15, 0],
        backgroundColor: '#836FFB',
        barThickness: 30,
      },
      {
        data: [20, 0, 0, 20, 20, 0],
        backgroundColor: '#6A9DFF',
        barThickness: 30,
      },
      {
        data: [5, 20, 0, 0, 10, 0],
        backgroundColor: '#66D7DE',
        barThickness: 30,
      },
    ],
  };

  const options = {
    indexAxis: 'y',
    scales: {
      x: {
        stacked: true,
        ticks: {
          stepSize: 25, 
          color: "rgba(0, 0, 0, 1)", 
          font: {
            size: 15,
          },
        },
      },
      y: {
        stacked: true,
        ticks: {
          color: "rgba(0, 0, 0, 1)", 
          font: {
            size: 15,
          },
        },
      },
      
    },
    plugins: {
      legend: {
        display: false, 
      },
    },
  };

  return <Bar data={data} options={options} />;
};

export default HorizontalStackedBarChart;
